import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSX: CultureInfo = {
  name: 'en-SX',
  displayName: 'English (Sint Maarten)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SX',
  parent: CultureInfoEn
};
